import {Card} from '../card';
import {InfoGroup} from '../info-group';

export class InformationCard extends Card<null> {
  infoGroups?: InfoGroup[];
  description2: string;
  description3: string;
}
